// productId -> book title, mirroring the novel list in pages/LandingPage.jsx.
// Reviews are stored against productId only, so the dashboard needs this to show
// which book a review belongs to. Keep in sync when a novel is added there.
export const BOOK_TITLES = {
  "Gareth-Bath-novels": "Gareth & Bart Novels",
  "8f7d9a62-3b1e-4e8a-9c5d-2f8b7a3e4d1c": "The Aussie's Spartan-Games",
  "2c4a6b8d-5e7f-4a9b-8c1d-3e5f7a9b2c4d": "We Won't Die Wondering",
  "1a3b5c7d-9e2f-4b6d-8a0c-2e4f6g8h0j2k": "The Roman-Death Of A Greek-Slave",
  "5d7e9f2a-4b6c-8d0e-2f4g-6h8j0k2l4m6n": "A Cattle-Station Faggot",
  "3f5g7h9j-2k4l-6m8n-0p2q-4r6s8t0u2v4w": "Dan Ericson: Norwegian Cop",
  "7k9l2m4n-6p8q-0r2s-4t6u-8v0w2x4y6z8a": "Mutilations",
  "5d7e9f2a-4b6c-8d0e-2f4g-6h8j0k2l4m7d": "The Perfect-S Universe",
};

export const bookTitle = (productId) => BOOK_TITLES[productId] || productId;
